import { CallIntelHooks } from '@frontend/api-call-intel';
import { getUser, isWeaveUser } from '@frontend/auth-helpers';
import { useScopedAppFlagStore } from '@frontend/scope';
import { CI_DEMO_WIDGET_FF } from '../constants';

export const useShowCallIntelWidgetsDemo = (): boolean => {
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const user = getUser();

  const isDemoWidgetEnabled = getFeatureFlagValue(CI_DEMO_WIDGET_FF);

  const hasCallIntelAccess = CallIntelHooks.useHasCallIntelFeature();

  const isWeaveDemoUser = user?.username.toLowerCase().includes('@demoweave');

  return isDemoWidgetEnabled && (isWeaveDemoUser || (isWeaveUser() && !hasCallIntelAccess));
};
